export default __webpack_public_path__ + "static/media/home-foto-testimonios-viajes-profile-tower-Incoming-desk-0.fbc708ed.jpg";